var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudienceEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 201,
    viewBox: "0 0 200 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_186_24097)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100.4,
    r: 87.5,
    fill: "#E9E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.695 74.8692L69.9473 66.2608L108.962 54.5232L113.712 63.1301L100.882 102.416L74.695 74.8692Z",
    fill: "#6E45EA",
    stroke: "black",
    strokeWidth: 1.19702,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9473 66.2603L74.695 74.8687L100.882 102.415L95.638 92.8926L69.9473 66.2603Z",
    fill: "#6137DE",
    stroke: "black",
    strokeWidth: 1.19702,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.1338 93.8094L69.9464 66.2628C81.011 57.7917 95.3577 53.21 108.963 54.5237L96.1338 93.8094Z",
    fill: "#875FFE",
    stroke: "black",
    strokeWidth: 1.19702,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4019 85.7864C66.8527 90.8005 61.4533 97.1774 58.0383 104.501C55.5266 109.887 54.3292 115.269 54.3144 120.382L51.2422 122.073L55.9905 130.674L99.5893 113.333L94.832 104.722L91.3459 104.662L73.4019 85.7864Z",
    fill: "#DACDFF",
    stroke: "black",
    strokeWidth: 1.19702,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6536 77.1797C62.1043 82.1939 56.705 88.5708 53.2899 95.8944C49.0128 105.067 48.5469 114.226 51.2422 122.068L94.841 104.726L68.6536 77.1797Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.19702,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.615 107.19C160.127 108.631 159.547 110.076 158.873 111.523C158.873 111.523 158.873 111.523 158.873 111.523L117.322 102.691L112.562 94.0789L121.712 89.2478L130.151 63.405C131.874 63.5713 133.584 63.832 135.275 64.1913C142.633 65.7555 148.719 68.997 153.264 73.3804L154.241 72.317L158.171 79.4941C162.921 87.2909 164.027 97.1072 160.615 107.19Z",
    fill: "#3302C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.873 111.523C159.547 110.076 160.127 108.631 160.615 107.19C164.027 97.1072 162.921 87.2909 158.171 79.4941L154.241 72.317L153.264 73.3804C148.719 68.997 142.633 65.7555 135.275 64.1913C133.584 63.832 131.874 63.5713 130.151 63.405L121.712 89.2478L112.562 94.0789L117.322 102.691L158.873 111.523ZM158.873 111.523C158.873 111.523 158.873 111.523 158.873 111.523Z",
    stroke: "black",
    strokeWidth: 1.19702,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.322 102.69L158.873 111.522L153.202 101.311L121.712 89.2476L112.562 94.0786L117.322 102.69Z",
    fill: "#2900A2",
    stroke: "black",
    strokeWidth: 1.19702,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.125 102.916C164.039 81.6533 153.474 60.4624 130.526 55.5846C128.836 55.2253 127.125 54.9645 125.403 54.7983L112.573 94.084L154.125 102.916Z",
    fill: "#410FD3",
    stroke: "black",
    strokeWidth: 1.19702,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3861 113.492L94.6367 104.885L136.19 113.719L140.937 122.324C137.416 129.875 131.785 136.42 124.96 141.502L99.3861 113.492Z",
    fill: "#6D24D5",
    stroke: "black",
    strokeWidth: 1.19702,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.6367 104.885L99.3861 113.492L124.96 141.502L120.213 132.896L94.6367 104.885Z",
    fill: "#5B19B9",
    stroke: "black",
    strokeWidth: 1.19702,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.19 113.718L94.6387 104.886L120.212 132.896C127.038 127.814 132.669 121.269 136.19 113.718Z",
    fill: "#7E33E9",
    stroke: "black",
    strokeWidth: 1.19702,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5845 134.429L53.2812 126.679L58.4121 129.7L99.5942 113.32L117.71 133.161L120.424 132.724L125.168 141.33C112.774 150.558 96.4399 154.965 81.6416 151.819C70.2262 149.393 61.8749 142.93 57.5845 134.429Z",
    fill: "url(#paint0_linear_186_24097)",
    stroke: "black",
    strokeWidth: 1.19702,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2483 122.054C54.801 132.391 63.846 140.439 76.8945 143.213C91.6928 146.358 108.027 141.952 120.421 132.723L94.8471 104.713L51.2483 122.054Z",
    fill: "#B936D3",
    stroke: "black",
    strokeWidth: 1.19702,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1387 93.4617L32.2536 89.8098C32.9421 89.3987 33.8335 89.6235 34.2447 90.312L43.6281 106.024C44.0392 106.713 43.8144 107.604 43.1259 108.015L37.011 111.667L26.1387 93.4617Z",
    fill: "#6137DE",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.8281,
    y: 95.439,
    width: 6.99558,
    height: 21.2049,
    rx: 1.45202,
    transform: "rotate(-30.8457 22.8281 95.439)",
    fill: "#6E45EA",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1159 96.1839C3.80495 91.9998 2.76557 85.4759 5.56292 80.1594L28.0074 37.5025L66.1767 74.5479L24.2095 98.2569C18.9789 101.212 12.4269 100.368 8.1159 96.1839Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1775 74.5482L47.0928 56.0255C41.9839 77.0428 22.9726 86.9389 14.8389 86.4047L24.2102 98.2572L66.1775 74.5482Z",
    fill: "#F1EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11591 96.1839C3.80495 91.9998 2.76557 85.4759 5.56292 80.1594L28.0075 37.5025L66.1768 74.5479L24.2095 98.2569C18.9789 101.212 12.4269 100.368 8.11591 96.1839Z",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.56255 80.1594C2.7652 85.4759 3.80457 91.9998 8.11553 96.1839C12.4265 100.368 18.9786 101.212 24.2091 98.2569L29.9748 94.9996C19.977 92.6914 10.1637 83.8137 8.64611 74.2989L5.56255 80.1594Z",
    fill: "#6137DE",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.9653,
    cy: 53.1035,
    rx: 17.8626,
    ry: 31.8845,
    transform: "rotate(-45.8561 50.9653 53.1035)",
    fill: "#6E45EA",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.4842,
    cy: 52.5698,
    rx: 13.641,
    ry: 26.0602,
    transform: "rotate(-45.8561 51.4842 52.5698)",
    fill: "#CABCF2",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4657 68.9308C47.5971 67.2128 44.7106 65.0044 41.9842 62.3583C39.2579 59.7122 36.9642 56.893 35.1612 54.077L44.9241 46.2023C46.7649 44.3057 51.1944 45.619 54.8176 49.1356C58.4409 52.6522 59.886 57.0405 58.0452 58.937L50.4657 68.9308Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.4834,
    cy: 52.5698,
    rx: 4.78554,
    ry: 9.14246,
    transform: "rotate(-45.8561 51.4834 52.5698)",
    fill: "#6E45EA",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.609 138.062C143.061 130.515 144.287 126.742 146.734 124.181C148.886 121.928 151.676 120.317 154.703 119.58C158.145 118.741 162.026 119.566 169.787 121.216L173.894 122.089C181.656 123.739 185.536 124.563 188.024 126.662L189.446 126.344L191.215 130.824C191.657 131.774 191.978 132.784 192.167 133.838C192.741 137.041 191.515 140.814 189.063 148.361L187.765 152.355C185.313 159.901 184.087 163.674 181.64 166.235C179.488 168.488 176.698 170.099 173.67 170.837C170.229 171.675 166.348 170.85 158.587 169.201L154.479 168.327C146.718 166.678 142.837 165.853 140.35 163.754C138.799 162.445 137.618 160.801 136.883 158.951L134.914 154.019L136.086 155.558C135.901 152.55 137.114 148.818 139.311 142.056L140.609 138.062Z",
    fill: "#A925C3",
    stroke: "black",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.585 133.002C141.037 125.456 142.263 121.683 144.71 119.122C146.862 116.869 149.652 115.258 152.679 114.52C156.121 113.682 160.002 114.507 167.763 116.156L171.871 117.029C179.632 118.679 183.512 119.504 186 121.603C188.188 123.449 189.638 125.961 190.143 128.779C190.717 131.982 189.491 135.755 187.039 143.301L185.741 147.295C183.289 154.842 182.063 158.615 179.616 161.176C177.464 163.429 174.674 165.04 171.647 165.777C168.205 166.616 164.324 165.791 156.563 164.141L152.455 163.268C144.694 161.618 140.813 160.794 138.326 158.695C136.138 156.849 134.688 154.337 134.183 151.519C133.609 148.316 134.835 144.542 137.287 136.996L138.585 133.002Z",
    fill: "#B936D3",
    stroke: "black",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.038 123.477L169.464 156.345M143.156 149.731L179.042 129.336",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.2096,
    cy: 2.2096,
    r: 2.2096,
    transform: "matrix(-1 0 0 1 174.242 67.3816)",
    fill: "#611FE2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.2096,
    cy: 2.2096,
    r: 2.2096,
    transform: "matrix(-1 0 0 1 81.8945 37.5029)",
    fill: "#611FE2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.2096,
    cy: 2.2096,
    r: 2.2096,
    transform: "matrix(-1 0 0 1 31.0039 128.854)",
    fill: "#611FE2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.03022,
    cy: 4.03022,
    r: 4.03022,
    transform: "matrix(-1 0 0 1 164.707 54.0911)",
    fill: "#611FE2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.03022,
    cy: 4.03022,
    r: 4.03022,
    transform: "matrix(-1 0 0 1 42.6523 118.781)",
    fill: "#611FE2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.03022,
    cy: 4.03022,
    r: 4.03022,
    transform: "matrix(-1 0 0 1 127.191 156.714)",
    fill: "#611FE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_186_24097",
    x1: 46.2367,
    y1: 133.074,
    x2: 117.609,
    y2: 148.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9117A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA25C4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_24097"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white",
    transform: "translate(0 0.399902)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudienceEmpty);
export default __webpack_public_path__ + "static/media/audience-empty.c1854dc70b9ee103546265222df25544.svg";
export { ForwardRef as ReactComponent };